import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { decode } from "shared/utils/Utils";

function PaymentSuccessPage() {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const homeBtnClick = () => {
        navigate(`/ws/${id}/homepage`);
    }
    const [data, setData] = useState();
    const [deviceCode, setDeviceCode] = useState();
    useEffect(() => {
        // const queryParams = new URLSearchParams(window.location.search);
        // const dataParams = queryParams.get('data');
        // const deviceCodeParams = queryParams.get('deviceCode');
        // 
        // 
        // 
        // // 결과 출력
        //  // "WzIsMV0=="
        //  // [[2,1]]

        // // 디코딩된 문자열 확인
        // const decodedString = decode(dataParams);
        // 
        // setData(decodedString);
        // setDeviceCode(deviceCodeParams);
    }, []);
    useEffect(() => {
        if (data) {

            const jsonArray = JSON.parse(data);
            
            // 변환된 결과를 담을 JSON 배열 생성
            const resultArray = [];

            // JSON 배열 순회
            for (let i = 0; i < jsonArray.length; i++) {
                // 현재 요소 가져오기
                const itemArray = jsonArray[i];

                // productCode와 quantity 추출
                const productCode = itemArray[0];
                const quantity = itemArray[1];

                // JSON 객체 생성 후 결과 배열에 추가
                const itemObject = {
                    productCode: productCode,
                    quantity: quantity
                };
                resultArray.push(itemObject);
            }

            // 결과 출력
            
            
            let machineData = {
                userId: "",
                code: "order",
                roomId: id,
                content: resultArray,
                deviceCode: deviceCode

            }
            
            requester.testOrder(machineData,(result) => {
                
            })
        }
    }, [data])
    return (
        <Container maxWidth={1200}>
            <VerticalFlex>
                <FlexChild>
                    <Center>
                        <P weight={"bold"} size={"min(3.2vw, 40px)"}>결제가 완료되었습니다 ! </P>
                    </Center>
                </FlexChild>
                <FlexChild>
                    <CustomButton onClick={homeBtnClick} text={"홈으로 가기"} />
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default PaymentSuccessPage;